import React, {useRef, useState} from "react";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import codeDataStore from "common/codedata/store/CodeDataStore";
import UI from "components/UI";
import UISelect from 'components/selectbox/UISelect';
import ModalPopup from "../../../../components/modal";

import useToggleState from 'components/hooks/useToggleState';
function ContentsContainer() {
	const modaladm8210p = useToggleState({});

	const [yearList, setYearList] = React.useState<any[]>([{value : new Date().getFullYear()+'', nm : new Date().getFullYear()+'년'}]);
	const [year,setYear] = useState(new Date().getFullYear()+'');
	const [yearPop,setYearPop] = useState(new Date().getFullYear()+'');


	//초기 데이터 설정
	const rowCnt = useRef<string>("20");
	const rowCnt_modal = useRef<string>("9999");


	const [onOff1, setOnOff1] = useState(true);
	const [onOff2, setOnOff2] = useState(true);
	const [onOff3, setOnOff3] = useState(true);
	const [onOff4, setOnOff4] = useState(true);
	const [onOff5, setOnOff5] = useState(true);
	const [onOff6, setOnOff6] = useState(true);
	const [onOff7, setOnOff7] = useState(true);

	let sheetCols7 = useRef<any>([]);

	const [modal8210IsOpen, setModal8210IsOpen] = useState(false);
	const [totalRowCnt_modal,setTotalRowCnt_modal] = useState(0);

	async function onClose(num) {
		if(num == '8210'){
			setModal8210IsOpen(false);
			// @ts-ignore
			IBSheet.sheet_modal.dispose();
		}
	}

	async function onAfterOpen(num) {

		ib_modal.create();

		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	}

	//페이지 건수별로 보기
	const handleSelect = (e) => {
		if(e.target.name === 'year'){
			setYear(e.target.value);
		}else if(e.target.name === 'yearPop'){
			setYearPop(e.target.value);
		}
	};

	function initCall(){
		let start = new Date().getFullYear() - 20;
		let end = new Date().getFullYear();
		let newYearList = [];
		for(let i = start; i <= end; i++){
			// @ts-ignore
			newYearList.push({value : i+'', nm : i+'년'})
		}
		setYearList(newYearList);
	}

	function numberDonAmt(evtParam){
		if(evtParam.Row.DON_AMT == null) return 0;
		let amt = evtParam.Row.DON_AMT;
		amt = amt/100000000;
		console.log(amt);
		return amt;
	}
	function numberSuppAmt(evtParam){
		if(evtParam.Row.SUPP_AMT == null) return 0;
		let amt = evtParam.Row.SUPP_AMT;
		amt = amt/100000000;
		return amt;
	}

	//date to String
	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	//만기도래일 계산
	function donDateFormula(evtParam) {
		if(evtParam.Row.DON_DATE == null) return '';
		let donDate = evtParam.Row.DON_DATE;
		return dateToStr(donDate);
	}

	//====== 그리드 공통 부 START
	var ib_modal = ib_modal||{};
	ib_modal = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt_modal.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "500px"

			},
			Def:{
				Row:{
					"CanFormula": 1
				}
			},
			"Cols": [
				{"Header": "No","Type": "Int","Name": "SEQ","RelWidth": 0.5,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "기업규모","Type": "Text","Name": "CORP_SIZE_CD_NM","RelWidth": 0.8,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "법인등록번호","Type": "Text","Name": "CORP_REG_NO","RelWidth": 1,"Align": "Center" ,"CanEdit": "0","CustomFormat": "######-#######"},
				{"Header": "사업자등록번호","Type": "Text","Name": "BIZ_NO","RelWidth": 1,"Align": "Center" ,"CanEdit": "0","CustomFormat": "###-##-#####"},
				{"Header": "기업명","Type": "Text","Name": "CORP_NM","RelWidth": 2,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "최초 출연일자","Type": "Text","Name": "DON_DATE","RelWidth": 1,"Align": "Center" ,"CanEdit": "0","Formula": donDateFormula},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				//초기 데이터 로딩
				doSearchPop('init');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;


			//sheetId
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet_modal', // 생성할 시트의 id
				el: 'modal_8210_List', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				//data: this.data // 생성될 시트의 정적데이터
			});


			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {

		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부 START
	var ib1 = ib1||{};
	ib1 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto"

			},
			Def:{
				Row:{
					CanFormula: 1
				}
			},
			"Cols": [
				{"Header": "년도별현황(신규)","Type": "Text","Name": "TITLE","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "1월","Type": "Int","Name": "1월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "2월","Type": "Int","Name": "2월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "3월","Type": "Int","Name": "3월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "4월","Type": "Int","Name": "4월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "5월","Type": "Int","Name": "5월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "6월","Type": "Int","Name": "6월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "7월","Type": "Int","Name": "7월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "8월","Type": "Int","Name": "8월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "9월","Type": "Int","Name": "9월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "10월","Type": "Int","Name": "10월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "11월","Type": "Int","Name": "11월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "12월","Type": "Int","Name": "12월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "합계","Type": "Int","Name": "합계","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},

			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				//초기 데이터 로딩
				doSearch('1');
			},
			//시트 더블클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				if(evtParam.kind != "Header"){
					if(evtParam.col != "TITLE" && evtParam.col != "합계" && evtParam.row.SEQ == 1){
						var sheet = evtParam.sheet;
						var row = sheet.getFocusedRow();
						setModal8210IsOpen(true);
					}
				}


			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet1', // 생성할 시트의 id
				el: 'sheetDiv1', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");

			//@ts-ignore
			IBSheet.sheet11.down2Excel({fileName: "연도별 현황(누적)_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}
	//====== 그리드 공통 부 START
	var ib11 = ib11||{};
	ib11 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto"

			},

			"Cols": [
				{"Header": "년도별현황(신규)","Type": "Text","Name": "TITLE","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "1월","Type": "Int","Name": "1월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "2월","Type": "Int","Name": "2월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "3월","Type": "Int","Name": "3월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "4월","Type": "Int","Name": "4월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "5월","Type": "Int","Name": "5월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "6월","Type": "Int","Name": "6월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "7월","Type": "Int","Name": "7월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "8월","Type": "Int","Name": "8월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "9월","Type": "Int","Name": "9월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "10월","Type": "Int","Name": "10월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "11월","Type": "Int","Name": "11월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "12월","Type": "Int","Name": "12월","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "합계","Type": "Int","Name": "합계","RelWidth": 1,"Align": "Right" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet11', // 생성할 시트의 id
				el: 'sheetDiv11', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");

			//@ts-ignore
			IBSheet.sheet11.down2Excel({fileName: "연도별 현황(누적)_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}
	//====== 그리드 공통 부 START
	var ib2 = ib2||{};
	ib2 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "250px"

			},
			"Cols": [
				{"Header": "순위","Type": "Text","Name": "RN","RelWidth": 0.3,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "출연기업명","Type": "Text","Name": "CORP_NM","RelWidth": 2,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "출연액","Type": "Int","Name": "DON_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				//doSearch('2');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet2', // 생성할 시트의 id
				el: 'sheetDiv2', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "출연현황_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}
	//====== 그리드 공통 부 START
	var ib3 = ib3||{};
	ib3 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "250px"

			},
			"Cols": [
				{"Header": "순위","Type": "Text","Name": "RN","RelWidth": 0.3,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "출연기업명","Type": "Text","Name": "CORP_NM","RelWidth": 2,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "출연액","Type": "Int","Name": "DON_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				//doSearch('3');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet3', // 생성할 시트의 id
				el: 'sheetDiv3', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "출연현황_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}
	//====== 그리드 공통 부 START
	var ib4 = ib4||{};
	ib4 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto"

			},
			"Cols": [
				{"Header": "No","Type": "Int","Name": "SEQ","RelWidth": 0.5,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "사업명","Type": "Text","Name": "BIZ_NM","RelWidth": 1.5,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "약칭","Type": "Text","Name": "BIZ_NM2","RelWidth": 1.5,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "출연기업수","Type": "Int","Name": "COMPANY","RelWidth": 1.5,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "출연액","Type": "Int","Name": "DON_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "지원금액","Type": "Int","Name": "SUPP_AMT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "지원중소기업수","Type": "Int","Name": "SUPP_CORP_CNT","RelWidth": 2,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "현황","Type": "Text","Name": "STATUS","RelWidth": 1,"Align": "Center" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				//doSearch('3');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet4', // 생성할 시트의 id
				el: 'sheetDiv4', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet4.down2Excel({fileName: "출연사업별 현황(누적)_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}
	//====== 그리드 공통 부 START
	var ib5 = ib5||{};
	ib5 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "700px"

			},
			"Cols": [
				{"Header": "No","Type": "Int","Name": "SEQ","RelWidth": 0.5,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "기금사용용도(상생법)","Type": "Text","Name": "NM","RelWidth": 1.5,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "지원금액","Type": "Int","Name": "SUPP_AMT","RelWidth": 1.5,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "지원 중소기업수","Type": "Int","Name": "SUPP_CORP_CNT","RelWidth": 1.5,"Align": "Right" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				//doSearch('3');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet5', // 생성할 시트의 id
				el: 'sheetDiv5', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "출연현황_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부 START
	var ib6 = ib6||{};
	ib6 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "700px"

			},
			"Cols": [
				{"Header": "No","Type": "Int","Name": "SEQ","RelWidth": 0.6,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "사업분야","Type": "Text","Name": "NM","RelWidth": 1.6,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "중소기업수","Type": "Int","Name": "SUPP_CORP_CNT","RelWidth": 1.6,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "지원금액","Type": "Int","Name": "SUPP_AMT","RelWidth": 1.6,"Align": "Right" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				//doSearch('3');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet6', // 생성할 시트의 id
				el: 'sheetDiv6', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "출연현황_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부 START
	var ib7 = ib7||{};
	ib7 = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt.current,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto"

			},
			"Cols": [
				{"Header": "No","Type": "Int","Name": "SEQ","RelWidth": 0.6,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "사업분야","Type": "Text","Name": "NM","RelWidth": 1.6,"Align": "Left" ,"CanEdit": "0"},
				{"Header": "중소기업수","Type": "Int","Name": "SUPP_CORP_CNT","RelWidth": 1.6,"Align": "Right" ,"CanEdit": "0"},
				{"Header": "지원금액","Type": "Int","Name": "SUPP_AMT","RelWidth": 1.6,"Align": "Right" ,"CanEdit": "0"},
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				//doSearch('3');
			},
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			sheetCols7.current = [
				{"Header": "성과지표","Type": "Text","Name": "NM","RelWidth": 0.5,"Align": "Center","CanEdit": "0"},
			];

			options.Cols = sheetCols7.current;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet7', // 생성할 시트의 id
				el: 'sheetDiv7', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "출연현황_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}



	//====== 그리드 데이터 가지고 오기  START
	async function doSearch(actionId:string) {
		let param:any = { "YEAR" : year };
		let url = 'adm_8200';

		setYearPop(year);


		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url: url,
			data: param
		})



		//전체데이터
		let result = response;

		console.log(result);

		let newList1:any = [];
		let newList11:any = [];
		let list = result.REC1;
		if(list.length != 0){
			let row1 = { "TITLE" : "출연기업수", "1월" : "", "2월" : "", "3월" : "", "4월" : "", "5월" : "", "6월" : "", "7월" : "", "8월" : "", "9월" : "", "10월" : "", "11월" : "", "12월" : "", "합계" : 0 }
			let row2 = { "TITLE" : "출연금액(억원)", "1월" : "", "2월" : "", "3월" : "", "4월" : "", "5월" : "", "6월" : "", "7월" : "", "8월" : "", "9월" : "", "10월" : "", "11월" : "", "12월" : "", "합계" : 0 }
			let row3 = { "TITLE" : "지원금액(억원)", "1월" : "", "2월" : "", "3월" : "", "4월" : "", "5월" : "", "6월" : "", "7월" : "", "8월" : "", "9월" : "", "10월" : "", "11월" : "", "12월" : "", "합계" : 0 }			
			let row4 = { "TITLE" : "지원 중소기업수", "1월" : "", "2월" : "", "3월" : "", "4월" : "", "5월" : "", "6월" : "", "7월" : "", "8월" : "", "9월" : "", "10월" : "", "11월" : "", "12월" : "", "합계" : 0 }
			
			// 엑셀다운로드용 억원 안나눈거
			let row22 = { "TITLE" : "출연금액(억원)", "1월" : "", "2월" : "", "3월" : "", "4월" : "", "5월" : "", "6월" : "", "7월" : "", "8월" : "", "9월" : "", "10월" : "", "11월" : "", "12월" : "", "합계" : 0 }
			let row33 = { "TITLE" : "지원금액(억원)", "1월" : "", "2월" : "", "3월" : "", "4월" : "", "5월" : "", "6월" : "", "7월" : "", "8월" : "", "9월" : "", "10월" : "", "11월" : "", "12월" : "", "합계" : 0 }

			let divide = 100000000;
			for(let i = 0; i < list.length; i++){
				let month = list[i].MONTH;
				if(month.substring(0,1) == '0') month = month.replaceAll('0', '');

				row1[month] = list[i].COMPANY;
				row1["합계"] = Number(row1["합계"]) + Number(list[i].COMPANY);
				
				row2[month] = list[i].DON_AMT/divide;
				row2["합계"] = Number(row2["합계"]) + Number(list[i].DON_AMT/divide);
				
				row3[month] = list[i].SUPP_AMT/divide;
				row3["합계"] = Number(row3["합계"]) + Number(list[i].SUPP_AMT)/divide;
				
				row4[month] = list[i].SUPP_CORP_CNT;
				row4["합계"] = Number(row4["합계"]) + Number(list[i].SUPP_CORP_CNT);
				
				row22[month] = list[i].DON_AMT;
				row22["합계"] = Number(row22["합계"]) + Number(list[i].DON_AMT);
				
				row33[month] = list[i].SUPP_AMT;
				row33["합계"] = Number(row33["합계"]) + Number(list[i].SUPP_AMT);
			}
			newList1.push(row1); newList1.push(row2); newList1.push(row3); newList1.push(row4);
			newList11.push(row1); newList11.push(row22); newList11.push(row33); newList11.push(row4);
		}


		//데이터 처리
		ib1.data = newList1;
		// @ts-ignore
		sheet1.loadSearchData (newList1);  //data 로딩 처리
		// @ts-ignore
		sheet1.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet1.reloadData();
		//@ts-ignore
		sheet1.rerender(1); //최종 수정된 내용을 화면에 반영한다.

		//데이터 처리
		ib11.data = newList11;
		// @ts-ignore
		sheet11.loadSearchData (newList11);  //data 로딩 처리
		// @ts-ignore
		sheet11.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet11.reloadData();
		//@ts-ignore
		sheet11.rerender(1); //최종 수정된 내용을 화면에 반영한다.

		//데이터 처리
		ib2.data = result.REC2;
		// @ts-ignore
		sheet2.loadSearchData (result.REC2);  //data 로딩 처리
		// @ts-ignore
		sheet2.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet2.reloadData();
		//@ts-ignore
		sheet2.rerender(1); //최종 수정된 내용을 화면에 반영한다.

		//데이터 처리
		ib3.data = result.REC3;
		// @ts-ignore
		sheet3.loadSearchData (result.REC3);  //data 로딩 처리
		// @ts-ignore
		sheet3.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet3.reloadData();
		// @ts-ignore
		sheet3.rerender(1); //최종 수정된 내용을 화면에 반영한다.

		//데이터 처리
		ib4.data = result.REC4;
		// @ts-ignore
		sheet4.loadSearchData (result.REC4);  //data 로딩 처리
		// @ts-ignore
		sheet4.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet4.reloadData();
		// @ts-ignore
		sheet4.rerender(1); //최종 수정된 내용을 화면에 반영한다.

		//데이터 처리
		ib5.data = result.REC5;
		// @ts-ignore
		sheet5.loadSearchData (result.REC5);  //data 로딩 처리
		// @ts-ignore
		sheet5.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet5.reloadData();
		// @ts-ignore
		sheet5.rerender(1); //최종 수정된 내용을 화면에 반영한다.

		//데이터 처리
		ib6.data = result.REC6;
		// @ts-ignore
		sheet6.loadSearchData (result.REC6);  //data 로딩 처리
		// @ts-ignore
		sheet6.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet6.reloadData();
		// @ts-ignore
		sheet6.rerender(1); //최종 수정된 내용을 화면에 반영한다.


		let newList:any = [];
		if(result.REC7.length != 0){
			let arr:any = {};
			arr["NM"] = "합계";
			for(let i = 0; i < result.REC7.length; i++){
				arr[result.REC7[i].QUA_TEXT] = result.REC7[i].QUA_REG_CNT;
				// @ts-ignore
				sheet7.addCol( result.REC7[i].QUA_TEXT, 1, -1, {"Header": result.REC7[i].QUA_TEXT,"Type": "Int", "RelWidth": 1,"Align": "Right","CanEdit": "0"}, true, false );
			}
			// @ts-ignore
			newList.push(arr);
		}


		//데이터 처리
		ib7.data = newList;


		// @ts-ignore
		sheet7.loadSearchData (newList);  //data 로딩 처리
		// @ts-ignore
		sheet7.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		//@ts-ignore
		sheet7.reloadData();
		// @ts-ignore
		sheet7.rerender(); //최종 수정된 내용을 화면에 반영한다.


	}

	//====== 그리드 데이터 가지고 오기  START
	async function doSearchPop(actionId:string) {
		let param:any = { "YEAR" : yearPop };
		let url = 'adm_8210';


		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url: url,
			data: param
		})



		//전체데이터
		let result = response.REC;

		console.log(result);

		setTotalRowCnt_modal(Object.keys(result).length);
		//데이터 처리
		ib_modal.data = result;


		// @ts-ignore
		sheet_modal.loadSearchData(result);  //data 로딩 처리
		// @ts-ignore
		sheet_modal.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함


	}

	// init
	React.useEffect(() => {

		//ib시트 생성
		ib1.create();
		ib11.create();
		ib2.create();
		ib3.create();
		ib4.create();
		ib5.create();
		ib6.create();
		ib7.create();

		initCall();

		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	},[])

	function isOpen(type, num){
		let first = 0;
		let other = 1;
		if(type == 'close'){
			first = 1;
			other = 0;
		}

		if(num == '1'){
			//@ts-ignore
			sheet1.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet1.renderBody();
		}else if(num == '2'){
			//@ts-ignore
			sheet2.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet2.renderBody();
		}else if(num == '3'){
			//@ts-ignore
			sheet3.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet3.renderBody();
		}else if(num == '4'){
			//@ts-ignore
			sheet4.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet4.renderBody();
		}else if(num == '5'){
			//@ts-ignore
			sheet5.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet5.renderBody();
		}else if(num == '6'){
			//@ts-ignore
			sheet6.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet6.renderBody();
		}else if(num == '7'){
			//@ts-ignore
			sheet7.getDataRows().map((e, idx) => {
				if(idx == 0 && type == 'close') e.Visible = first;
				else  e.Visible = other;

				return e;
			});
			//@ts-ignore
			sheet7.renderBody();
		}


		//true -> 펼친상태 / type -> close 접으려는 상태
		//false -> 접힌상태 / type -> open 펼치려는 상태
		if(num == '2'){
			if(type == 'close' && onOff3 == false){
				$('#sheetDiv2').css('height', '100px')
				$('#sheetDiv3').css('height', '100px')
			}else{
				$('#sheetDiv2').css('height', '250px')
				$('#sheetDiv3').css('height', '250px')
			}
		}
		if(num == '3'){
			if(type == 'close' && onOff2 == false){
				$('#sheetDiv2').css('height', '100px')
				$('#sheetDiv3').css('height', '100px')
			}else{
				$('#sheetDiv2').css('height', '250px')
				$('#sheetDiv3').css('height', '250px')
			}
		}

		if(onOff5 == false || onOff6 == false){
			$('#sheetDiv5').css('height', '100px')
			$('#sheetDiv6').css('height', '100px')
		}else if(onOff5 && onOff6){
			$('#sheetDiv5').css('height', '700px')
			$('#sheetDiv6').css('height', '700px')
		}



	}

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">보고서</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">연도별 현황통계</h1>

				<form className="sf sf-1row sf-2col mb30">
					<div className="inner">
						<div className="sf-item">
							<p className="sf-key">년도</p>
							<div className="sf-value">
								<div className="sl sl-md w120">
									<select name="year" id="year" value={year} onChange={(handleSelect)}>
										{yearList.map((year, idx) => (
											<option value={year.value}>{year.nm}</option>
										))}
									</select>
								</div>
							</div>
						</div>
					</div>
					<button className="bt" data-color="pri" data-size="md"  type="button" onClick={() => doSearch('search')}>조회</button>
				</form>

					<div className="hz-root hz-sb mb10">
						<h3 className="section-title">연도별 현황</h3>
					</div>
					<div id={'sheetDiv1'} className="ibsheet mb40">[D] IBSHEET 영역</div>
					<div style={ { display:"none" } } id={'sheetDiv11'} className="ibsheet mb40">[D] IBSHEET 영역</div>


					<div className="pt">
						<div className="row">
							<div className="col col-5 mr15">
								<div className="hz-root hz-sb mb10">
									<h3 className="section-title">상위출연 민간기업</h3>
									<div className="hz-item hz-root hz-gap5">
										{ onOff2 == true && <Button color="gray-o" size="sm" onClick={() => { isOpen('close', '2'); setOnOff2(false); } }>접기</Button> }
										{ onOff2 == false && <Button color="gray-o" size="sm" onClick={() => { isOpen('open', '2'); setOnOff2(true); } }>펼치기</Button> }
									</div>
								</div>
								<div id={'sheetDiv2'}  className="ibsheet mb40">[D] IBSHEET 영역</div>
							</div>
							<div className="col col-5 ml15">
								<div className="hz-root hz-sb mb10">
									<h3 className="section-title">상위출연 공공기관</h3>
									<div className="hz-item hz-root hz-gap5">
										{ onOff3 == true && <Button color="gray-o" size="sm" onClick={() => { isOpen('close', '3'); setOnOff3(false); } }>접기</Button> }
										{ onOff3 == false && <Button color="gray-o" size="sm" onClick={() => { isOpen('open', '3'); setOnOff3(true); } }>펼치기</Button> }
									</div>
								</div>
								<div id={'sheetDiv3'}  className="ibsheet mb40">[D] IBSHEET 영역</div>
							</div>
						</div>
					</div>

					<div className="hz-root hz-sb mb10">
						<h3 className="section-title">출연사업별 현황(누적)</h3>
						<div className="hz-item hz-root hz-gap5">
							{ onOff4 == true && <Button color="gray-o" size="sm" onClick={() => { isOpen('close', '4'); setOnOff4(false); } }>접기</Button> }
							{ onOff4 == false && <Button color="gray-o" size="sm" onClick={() => { isOpen('open', '4'); setOnOff4(true); } }>펼치기</Button> }
							<Button color="gray-o" size="sm" onClick={()=> ib4.exportData()}>다운로드</Button>
						</div>
					</div>
					<div id={'sheetDiv4'} className="ibsheet mb40">[D] IBSHEET 영역</div>

					<div className="pt">
						<div className="row">
							<div className="col col-5 mr15">
								<div className="hz-root hz-sb mb10">
									<h3 className="section-title">기금사용용도(상생법)</h3>
									<div className="hz-item hz-root hz-gap5">
										{ onOff5 == true && <Button color="gray-o" size="sm" onClick={() => { isOpen('close', '5'); setOnOff5(false); } }>접기</Button> }
										{ onOff5 == false && <Button color="gray-o" size="sm" onClick={() => { isOpen('open', '5'); setOnOff5(true); } }>펼치기</Button> }
									</div>
								</div>
								<div id={'sheetDiv5'} className="ibsheet mb40">[D] IBSHEET 영역</div>
							</div>
							<div className="col col-5 ml15">
								<div className="hz-root hz-sb mb10">
									<h3 className="section-title">사업분야</h3>
									<div className="hz-item hz-root hz-gap5">
										{ onOff6 == true && <Button color="gray-o" size="sm" onClick={() => { isOpen('close', '6'); setOnOff6(false); } }>접기</Button> }
										{ onOff6 == false && <Button color="gray-o" size="sm" onClick={() => { isOpen('open', '6'); setOnOff6(true); } }>펼치기</Button> }
									</div>
								</div>
								<div id={'sheetDiv6'} className="ibsheet mb40">[D] IBSHEET 영역</div>
							</div>
						</div>
					</div>

					<div className="hz-root hz-sb mb10">
						<h3 className="section-title">주요성과</h3>
					</div>
					<div id={'sheetDiv7'} className="ibsheet mb40">[D] IBSHEET 영역</div>
				</main>
			</div>

			{/* modal - 8210p*/}
			<ModalPopup
				open={modal8210IsOpen}
				title="출연기업수"
				size="mid"
				onClose={() => onClose('8210')}
				onAfterOpen={() => onAfterOpen('8210')}
			>
				<div className="modal-con">
					<form className="sf sf-1row sf-2col mbmodal-bottom30">
						<div className="inner">
							<div className="sf-item">
								<p className="sf-key">년도</p>
								<div className="sf-value">
									<div className="sl sl-md w120">
										<select name="yearPop" id="yearPop" value={yearPop} onChange={(handleSelect)}>
											{yearList.map((year, idx) => (
												<option value={year.value}>{year.nm}</option>
											))}
										</select>
									</div>
								</div>
							</div>
						</div>
						<button className="bt" data-color="pri" data-size="md"  type="button" onClick={() => doSearchPop('search')}>조회</button>
					</form>

					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt_modal}</em>건
						</div>
					</div>

					<div id="modal_8210_List" >[D] IBSHEET 영역</div>

				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={() => onClose('8210')}>닫기</Button>
					</div>
				</div>
			</ModalPopup>

		</PageContainer>
	);
}
export default ContentsContainer;